import {FormattedMessage} from "react-intl";

import styled from "@emotion/styled";

import Typography from "@mui/material/Typography";

import error from "../assets/images/error.png";
import {safeUrl, useSchool} from "../school/SchoolContext";

function Error() {
    const school = useSchool();
    const contactUrl = safeUrl(school.contactUrl);
    const contactEmail = school.contactEmail;
    return (
        <Container>
            <div>
                <Image src={error} alt="success"></Image>

                <StyledTypography component="h1" variant="h4" align="center">
                    <FormattedMessage id="error_title"/>
                </StyledTypography>

                {contactUrl && (
                    <RedTypography component="h2" variant="h6" align="center">
                        <FormattedMessage id="error_text_1"/>
                        <a href={contactUrl} target="_blank"
                           rel="noopener noreferrer"><FormattedMessage id="form_info_contact_link"/></a>
                    </RedTypography>
                )}

                {contactEmail && (
                    <RedTypography component="h2" variant="h6" align="center">
                        <FormattedMessage id="error_text_2"/> <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
                    </RedTypography>
                )}

                {!contactUrl && !contactEmail && (
                    <RedTypography component="h2" variant="h6" align="center">
                        <FormattedMessage id="error_text_generic"/>
                    </RedTypography>
                )}
            </div>
        </Container>
    );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 100vh;
`;

const Image = styled.img`
  padding: 24px;
  width: 100px;
  height: 100px;
  display: block;
  margin: auto;
`;

const StyledTypography = styled(Typography)`
  margin-top: 16px;
  color: #666;
`;

const RedTypography = styled(Typography)`
  margin-top: 16px;
  color: red;
`;

export default Error;
